import { cn } from "@/lib/utils";
import React from "react";
import { CheckCircle2, Zap, ShieldCheck, ArrowUpDown, Infinity, Activity, BarChart3, Globe } from "lucide-react";

export function FeaturesSectionWithHoverEffects() {
  const features = [
    { title: "Zero-fee Perpetuals", description: "Trade perps with 0 maker/taker protocol fees.", icon: <CheckCircle2 /> },
    { title: "Hybrid Mechanism", description: "Robust design combining on-chain risk with off-chain speed.", icon: <Zap /> },
    { title: "Built on Hedera", description: "Fast finality, low fees, and predictable performance.", icon: <Globe /> },
    { title: "Long & Short", description: "Go long or short on popular crypto assets.", icon: <ArrowUpDown /> },
    { title: "Deepening DeFi on Hedera", description: "Designed to plug into a growing Hedera DeFi stack.", icon: <Infinity /> },
    { title: "Risk Engine", description: "Transparent funding, liquidation, and margin controls.", icon: <ShieldCheck /> },
    { title: "Real-time Metrics", description: "Live PnL, funding, and mark prices at a glance.", icon: <BarChart3 /> },
    { title: "Low Latency", description: "Snappy order entry with smooth execution.", icon: <Activity /> },
  ];
  return (
    <section id="features" className="bg-background py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative z-10 max-w-7xl mx-auto">
        {features.map((feature, index) => (
          <Feature key={feature.title} {...feature} index={index} />
        ))}
      </div>
    </section>
  );
}

const Feature = ({ title, description, icon, index }: { title: string; description: string; icon: React.ReactNode; index: number }) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r  py-10 relative group/feature dark:border-neutral-800",
        (index === 0 || index === 4) && "lg:border-l dark:border-neutral-800",
        index < 4 && "lg:border-b dark:border-neutral-800",
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-neutral-600 dark:text-neutral-400">{icon}</div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-blue-500 transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">{title}</span>
      </div>
      <p className="text-sm text-neutral-600 dark:text-neutral-300 max-w-xs relative z-10 px-10">{description}</p>
    </div>
  );
};


